module.exports = ".flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n\ndiv img {\n  max-height: 85vh;\n  max-width: 85vw; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/show-image-dialog/show-image-dialog.component.scss
// module id = ./src/app/shared/components/show-image-dialog/show-image-dialog.component.scss
// module chunks = main